import { render, staticRenderFns } from "./LampMtap6V1ControllerTelemetryCard.vue?vue&type=template&id=24aaf897&scoped=true&"
import script from "./LampMtap6V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./LampMtap6V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./LampMtap6V1ControllerTelemetryCard.vue?vue&type=style&index=0&id=24aaf897&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aaf897",
  null
  
)

export default component.exports